module.exports = __webpack_public_path__ + "assets/img/search.6b34f061.svg";